import { APPROVAL_STATUS_LIST } from '../const'
import { BATCH_STATUS_LIST } from '../const'

// ------------------申请列表页------------------
export const SEARCH_SCHEMA = [
  {
    itemName: 'companyName',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'companyCode',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'status',
    label: '状态',
    type: 'select',
    selectList: APPROVAL_STATUS_LIST,
  },
]

// ------------------批量申请页------------------
export const BATCH_SEARCH_SCHEMA = [
  {
    itemName: 'id',
    label: '批量申请编号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '添加时间',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'status',
    label: '状态',
    type: 'select',
    selectList: BATCH_STATUS_LIST,
  },
]
